import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import { Spinner } from '../../Loaders/Loaders'
import EntitySelectionList from '../../WorkviewManager/PaperProcessModel/EntitySelectionList'
import WVMNotes from '../../Notes/WVMNotes'
import { ContextButtonControl } from '../../WorkviewManager/PaperProcessModel/PaperProcessModal'
import {
  SET_LEGACY_FILING_DETAILS,
  SET_SEARCH_RESULTS,
  SET_RECORD_SEARCH_QUERY,
  SET_STAFF_DRAFT,
  defaultRecordSearchQuery,
} from '../Workview2Reducer'
import * as api from '../../../requests'
// import { useHistory } from 'react-router'
import LegacyFilingForm from './LegacyFilingForm'
import './LegacyFilingsModal.scss'

const LegacyFilingsModal = ({ navToCorrespondence, closePaperModalUnlockItem, refreshView }) => {
  const dispatch = useDispatch()
  const { selectedRow, legacyFilingDetails } = useSelector((state) => state.workview2, shallowEqual)
  const [showNoPaymentConfirm, setShowNoPaymentConfirm] = useState(false)
  const [loadingNoPaymentData, setLoadingNoPaymentData] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedSourceType, setSelectedSourceType] = useState(0)
  const [sourceTypeOptions, setSourceTypeOptions] = useState([])
  const formRef = useRef()

  useEffect(() => {
    setLoadingNoPaymentData(true)
    api.DOES_IMAGE_ENVELOPE_HAVE_PAYMENT(
      selectedRow.ImageEnvelopeId,
      (hasPayment) => {
        setLoadingNoPaymentData(false)
        setShowNoPaymentConfirm(!hasPayment)
      },
      (err) => {
        setLoadingNoPaymentData(false)
        setShowNoPaymentConfirm(false)
        console.error(err.Message)
      }
    )
  }, [selectedRow.ImageEnvelopeId])

  useEffect(() => {
    api.GET_LEGACY_FILING_CONFIG_SOURCE_TYPE_IDS(
      (sourceTypes) => {
        console.log(sourceTypes)
        setSourceTypeOptions(sourceTypes.map((type) => ({ value: type.Id, label: type.Name })))
      },
      (err) => console.error(err)
    )
    return () => {
      dispatch({
        type: SET_SEARCH_RESULTS,
        results: [],
      })
      dispatch({
        type: SET_RECORD_SEARCH_QUERY,
        query: defaultRecordSearchQuery,
      })
      dispatch({ type: SET_STAFF_DRAFT, staffDraft: null })
      dispatch({ type: SET_LEGACY_FILING_DETAILS, legacyFilingDetails: undefined })
    }
  }, [])

  useEffect(() => {
    if (selectedSourceType && +selectedSourceType > 0) {
      api.GET_LEGACY_FILING_CONFIG_BY_SOURCE_TYPE_ID(
        +selectedSourceType,
        (config) => {
          console.log(config)
          dispatch({
            type: SET_LEGACY_FILING_DETAILS,
            legacyFilingDetails: { ...legacyFilingDetails, Config: config },
          })
        },
        (err) => console.error(err)
      )
    }
  }, [selectedSourceType])

  const showEntitySelection = useMemo(() => {
    return +selectedSourceType !== 0 && !selectedRow.RecordToAmend
  }, [selectedRow, selectedSourceType])

  const showLegacyFilingForm = useMemo(() => {
    return +selectedSourceType !== 0 && selectedRow.RecordToAmend
  }, [selectedRow, selectedSourceType])

  const submitFiling = () => {
    formRef.current.submitFiling()
  }

  return (
    <div className="wvm-modal">
      <div className="flex-column-wrapper paper-process-container">
        {(loadingNoPaymentData || loading) && (
          <Spinner className="page-loader" themeColor="neutral" />
        )}
        <br />
        {!showLegacyFilingForm && (
          <SelectBox
            label="Source Type"
            value={selectedSourceType}
            onChange={(val) => {
              setSelectedSourceType(val)
              dispatch({
                type: SET_LEGACY_FILING_DETAILS,
                legacyFilingDetails: {
                  ...legacyFilingDetails,
                  SourceTypeId: +val,
                },
              })
            }}
            options={sourceTypeOptions}
          />
        )}
        {showEntitySelection && <EntitySelectionList />}
        {showLegacyFilingForm && (
          <LegacyFilingForm
            ref={formRef}
            selectedSourceType={selectedSourceType}
            setLoading={setLoading}
            closePaperModalUnlockItem={closePaperModalUnlockItem}
          />
        )}
      </div>
      {showNoPaymentConfirm && (
        <div className="no-payment-warning">No Payment found in Image Envelope.</div>
      )}
      <WVMNotes />
      <ContextButtonControl
        showSubmitButton={showLegacyFilingForm}
        disableSubmitButton={loading}
        onSubmit={submitFiling}
        navToCorrespondence={navToCorrespondence}
        refreshView={refreshView}
        closePaperModalUnlockItem={closePaperModalUnlockItem}
      />
    </div>
  )
}

export default LegacyFilingsModal
